import React from "react";
import {FilterItem, FilterItemProps, InputEditor, SelectEditor} from "../tablefilter/TableFilter";
import {SearchFilter} from "../tablefilter/SearchFilter";

interface LicensesProps extends FilterItemProps {
    licenses?: string[];
}

function LicensesItem(props: LicensesProps) {
    return (
        <SelectEditor
            options={props.licenses?.map(license => ({
                value: license,
                label: <span style={{display: "inline-block"}} className={"selection-item-text"}>{license}</span>
            }))}
            multiple={true}
            value={props.value}
            onChange={value => props.onChange(value)}
        />
    )
}

function NameItem(props: FilterItemProps) {
    return (
        <InputEditor
            value={props.value}
            onChange={value => props.onChange(value)}
        />
    )
}

interface FilterProps {
    className?: string;
    values?: any;
    onChange: (values: any) => void;
    immediateMode?: boolean;
    licenses?: string[];
    persistentStateIdent?: string;
}

function SoftwareLicenseOverrideFilter(filterProps: FilterProps) {
    const items: FilterItem[] = [
        {
            name: "purl",
            key: "purl",
            label: "Package URL",
            render: (props) => <NameItem {...props} />
        },
        {
            name: "licenses",
            key: "licenses",
            label: "Licenses",
            render: (props) => <LicensesItem {...props} licenses={filterProps.licenses}/>
        },
    ];

    return (
        <SearchFilter
            items={items}
            className={filterProps.className}
            values={filterProps.values}
            defaultValues={{purl: "", licenses: []}}
            persistentStateIdent={filterProps.persistentStateIdent}
            defaultActiveFilterNames={["purl", "licenses"]}
            immediateMode={filterProps.immediateMode}
            onChange={filterProps.onChange}
        />
    )
}

export default SoftwareLicenseOverrideFilter;
